import { EXPORT_ROW_LIMIT } from '@his/shared';

export type QueryParams = Record<string, string | number | boolean | undefined | null>;

export function nextCursorOf<T extends { id: string }>(rows: readonly T[], pageSize: number): string | undefined {
  if (rows.length === 0 || rows.length < pageSize) return undefined;
  return rows[rows.length - 1].id;
}

export function withExport(params: QueryParams): QueryParams {
  return { ...params, limit: undefined, offset: undefined, cursor: undefined, export: true };
}

export function exportWasCut(rowCount: number): boolean {
  return rowCount >= EXPORT_ROW_LIMIT;
}

export function exportCutMessage(): string {
  return `The export was cut at ${EXPORT_ROW_LIMIT.toLocaleString('en-US')} rows. Narrow the period or the filters and export again to get the rest.`;
}
